import { TabsList } from 'components/Navigation/Tabs/TabsList';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePaymentReconciliationStats } from 'services/repositories/paymentReconciliation/paymentReconciliation';

type Props = {
  selectedIndex: number;
  onTabSelected: (index: number) => void;
};

export function PaymentReconciliationTabs({ selectedIndex, onTabSelected }: Props) {
  const { data } = usePaymentReconciliationStats();
  const { t } = useTranslation();

  const tabs = useMemo(() => {
    return [
      {
        label: t('paymentReconciliation:list.tabs.open'),
        badge: data?.data.open,
      },
      {
        label: t('paymentReconciliation:list.tabs.completed'),
      },
    ];
  }, [data?.data.open, t]);

  return <TabsList onChange={onTabSelected} tabs={tabs} selected={selectedIndex} />;
}
